import _ from "lodash";
import React, { useState, useEffect } from "react";
import { getCookie, getUrlParameter } from "../../utils";
import NoHashtagWelcome from "./NoHashtagWelcome";
import MoreSignsMenu from "./MoreSignsMenu";

type Props = {};

var cookiehash = getCookie("sshash");

var placeHash = getUrlParameter('hash');

if (placeHash !== "") {
    document.cookie = "sshash=" + placeHash;
};

if (!placeHash) {
    placeHash = cookiehash;
};

const SignShop: React.FC<Props> = (props: Props) => {
    let [hash, setHash] = useState(placeHash);
    if (!hash) {
        hash = "#MyWeddingHashtag";
    }
    if (!_.startsWith(hash, "#")) {
        hash = "#" + hash;
    }
    const hashq = _.trimStart(hash, "#");

    const [numberModal, setNumberModal] = useState(false);
    const onClose = () => {
        setNumberModal(false);
        if (!hash) {
            setHash("MyWeddingHashtag");
        }
    }
    const [more, setMore] = useState(false);
    const onCloseMore = () => {
        setMore(false);
    };
    const onOpenMore = () => {
        setMore(true);
    };

    useEffect(() => {
        function handler(e) {
            const el = document.querySelector(".sign-shop-buttons-container");
            if (!el) {
                return;
            }
            if (window.scrollY > 500) {
                el.classList.add("sign-nav-fixed");
            } else {
                el.classList.remove("sign-nav-fixed");
            }
        }

        document.addEventListener("scroll", handler);

        return () => {
            document.removeEventListener("scroll", handler);
        };
    });

    useEffect(() => {
        if (localStorage.signhash) {
            setHash(localStorage.signhash);
            return;
        }

        setNumberModal(true);
    }, []);

    return (
        <>
        <div className="sign-shop-banner">
            <div className="ss-banner-box">
                <h1 className="lph1">Sign Shop</h1>
                <p>It’s super important that your guests know exactly where to send those <span className="green bold typew">CANDID PICS</span> that they’ll snap on their hashs! The best way to make this happen is by placing creative signage and table cards all around your venue - at the entrance, on all of your guests’ tables, and at the bar. Create and download your <span className="pink bold type">FREE SIGNS</span> now and also explore our variety of table card designs! </p>
                <img src="https://tacboard.com/img/sign-shop-banner-pic-has.png" className="sign-shop-banner-pic"/>
            </div>
         </div> 
		<div className="lp-container wed-sign-shop" style={{margin: "0 auto"}}>
        <section id="sign-shop-container" className="content-section">
            <div className="welcome-overview full-inner-container">
                <h3>Free Signs for <span style={{fontSize: "2.6rem", fontFamily: "Lobster", color: "#333", fontStyle: "italic"}} id="forHash" className="change-num-og">{hash}</span></h3>
                <div className="sign-shop-buttons-container">
                    <div className="change-hash" onClick={() => setNumberModal(!numberModal)}>Insert Hashtag</div>
                    <div className="more-signs" onClick={onOpenMore}>☰   See More Signs</div>
                </div>

                <div className="sign-list">
                    <ul className="sign-list-container">
                        <li>
                            <a className="open-sign" href={"/sign/share-the-love-1?hash="+hashq}>
                                <div className="sign-image-container">
                                    <img src="/img/share-the-love-01-hash.svg" />
                                    <div className="mini-number mn1" style={{color: "#000",  fontSize: "20px", fontFamily: "Oswald, sans-serif"}}>{hash}</div>
                                </div>
                                <span>view larger &amp; download</span>
                            </a>
                        </li>
                        <li>
                            <a className="open-sign" href={"/sign/share-the-love-2-hash?hash="+hashq}>
                                <div className="sign-image-container">
                                    <img src="/img/share-the-love-02-hash.svg" />
                                    <div className="mini-number mn1" style={{color: "#000",  fontSize: "20px", fontFamily: "Oswald, sans-serif"}}>{hash}</div>
                                </div>
                                <span>view larger &amp; download</span>
                            </a>
                        </li>
                        <li>
                            <a className="open-sign" href={"/sign/share-the-love-3-hash?hash="+hashq}>
                                <div className="sign-image-container">
                                    <img src="/img/share-the-love-03-hash.svg" />
                                    <div className="mini-number mn1" style={{color: "#000",  fontSize: "20px", fontFamily: "Oswald, sans-serif"}}>{hash}</div>
                                </div>
                                <span>view larger &amp; download</span>
                            </a>
                        </li>
                        <li>
                            <a className="open-sign" href={"/sign/capture-the-love-1-hash?hash="+hashq}>
                                <div className="sign-image-container">
                                    <img src="/img/capture-the-love-01-hash.svg" />
                                    <div className="mini-number mn1" style={{color: "#000",  fontSize: "20px", fontFamily: "Oswald, sans-serif"}}>{hash}</div>
                                </div>
                                <span>view larger &amp; download</span>
                            </a>
                        </li>
                        <li>
                            <a className="open-sign" href={"/sign/capture-the-love-2-hash?hash="+hashq}>
                                <div className="sign-image-container">
                                    <img src="/img/capture-the-love-02-hash.svg" />
                                    <div className="mini-number mn1" style={{color: "#000",  fontSize: "20px", fontFamily: "Oswald, sans-serif"}}>{hash}</div>
                                </div>
                                <span>view larger &amp; download</span>
                            </a>
                        </li>
                        <li>
                            <a className="open-sign" href={"/sign/capture-the-love-3-hash?hash="+hashq}>
                                <div className="sign-image-container">
                                    <img src="/img/capture-the-love-03-hash.svg" />
                                    <div className="mini-number mn1" style={{color: "#000",  fontSize: "20px", fontFamily: "Oswald, sans-serif"}}>{hash}</div>
                                </div>
                                <span>view larger &amp; download</span>
                            </a>
                        </li>
                        <li>
                            <a className="open-sign" href={"/sign/capture-the-love-4-hash?hash="+hashq}>
                                <div className="sign-image-container">
                                    <img src="/img/capture-the-love-04-hash.svg" />
                                    <div className="mini-number mn1" style={{color: "#000",  fontSize: "20px", fontFamily: "Oswald, sans-serif"}}>{hash}</div>
                                </div>
                                <span>view larger &amp; download</span>
                            </a>
                        </li>
                        <li>
                            <a className="open-sign" href={"/sign/capture-the-love-5-hash?hash="+hashq}>
                                <div className="sign-image-container">
                                    <img src="/img/capture-the-love-05-hash.svg" />
                                    <div className="mini-number mn1" style={{color: "#000",  fontSize: "20px", fontFamily: "Oswald, sans-serif"}}>{hash}</div>
                                </div>
                                <span>view larger &amp; download</span>
                            </a>
                        </li>
                        <li>
                            <a className="open-sign" href={"/sign/capture-the-love-6-hash?hash="+hashq}>
                                <div className="sign-image-container">
                                    <img src="/img/capture-the-love-06-hash.svg" />
                                    <div className="mini-number mn1" style={{color: "#000",  fontSize: "20px", fontFamily: "Oswald, sans-serif"}}>{hash}</div>
                                </div>
                                <span>view larger &amp; download</span>
                            </a>
                        </li>
                        <li>
                            <a className="open-sign" href={"/sign/see-it-snap-it-share-it-1-hash?hash="+hashq}>
                                <div className="sign-image-container">
                                    <img src="/img/see-it-snap-it-share-it-01-hash.svg" />
                                    <div className="mini-number mn1" style={{color: "#000",  fontSize: "20px", fontFamily: "Oswald, sans-serif"}}>{hash}</div>
                                </div>
                                <span>view larger &amp; download</span>
                            </a>
                        </li>
                        <li>
                            <a className="open-sign" href={"/sign/see-it-snap-it-share-it-2-hash?hash="+hashq}>
                                <div className="sign-image-container">
                                    <img src="/img/see-it-snap-it-share-it-02-hash.svg" />
                                    <div className="mini-number mn1" style={{color: "#000",  fontSize: "20px", fontFamily: "Oswald, sans-serif"}}>{hash}</div>
                                </div>
                                <span>view larger &amp; download</span>
                            </a>
                        </li>
                        <li>
                            <a className="open-sign" href={"/sign/see-it-snap-it-share-it-3-hash?hash="+hashq}>
                                <div className="sign-image-container">
                                    <img src="/img/see-it-snap-it-share-it-03-hash.svg" />
                                    <div className="mini-number mn1" style={{color: "#000",  fontSize: "20px", fontFamily: "Oswald, sans-serif"}}>{hash}</div>
                                </div>
                                <span>view larger &amp; download</span>
                            </a>
                        </li>
                    </ul>
                </div>

            </div>
        </section>

    </div>
        <NoHashtagWelcome display={numberModal} change={setHash} close={onClose}/>
        {more && <MoreSignsMenu onClose={onCloseMore} />}
         </>
    )
}

export default SignShop;
